module.exports = __webpack_public_path__ + "img/capa2.2d55c050.webp";